import React from 'react';
import OlcButton from '~/components/General/OlcButton';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { success, failure } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import request from '~/utils/request';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

// styles
import './styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const UnverifiedEmail = (props) => {
  const { isOpen, handleCloseModal } = props;
  const dispatch = useDispatch();

  const reSendEmail = async () => {
    try {
      const reSendEmail = await request.get('/auth/user/resend-verification-email');
      handleCloseModal();
      dispatch(success(reSendEmail.data.message));
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message || MESSAGES.GENERAL_ERROR));
      return error;
    }
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        className="unverifiedEmailModal"
      >
        <DialogContent className="unverifiedEmailModal__content">
          <Box className="unverifiedEmailModal__header">
            <Typography gutterBottom variant="h4">
              {MESSAGES.UNVERIFIED_EMAIL.TITLE}
            </Typography>
          </Box>
          <Box className="unverifiedEmailModal__body">
            <Typography gutterBottom>{MESSAGES.UNVERIFIED_EMAIL.HEADING}</Typography>
          </Box>
          <Box className="unverifiedEmailModal__footer">
            <OlcButton
              className="unverifiedEmailModal__resendButton"
              variant="primary"
              onClick={reSendEmail}
            >
              {MESSAGES.UNVERIFIED_EMAIL.RESEND_BTN_TEXT}
            </OlcButton>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default UnverifiedEmail;
